import { AlertTriangle, ArrowRightLeft } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function StockTakeApplyDialog({ open, onClose, onConfirm, busy, items, comparison }) {
  const liveRows = comparison.filter((r) => r.live > 0).length;
  const notCounted = comparison.filter((r) => r.live > 0 && r.draft === 0);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="max-w-lg" data-testid="stocktake-apply-dialog">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            <ArrowRightLeft className="h-5 w-5 text-primary" /> Switch to new stock?
          </DialogTitle>
          <DialogDescription>This replaces all live raw-material stock with your counted draft.</DialogDescription>
        </DialogHeader>
        <ul className="text-sm space-y-2">
          <li>• All current intakes ({liveRows} material{liveRows !== 1 ? "s" : ""} in stock) are set to <b>0 remaining</b>. The records stay in history for traceability.</li>
          <li>• <b>{items.length}</b> new intake{items.length !== 1 ? "s" : ""} will be created, each with a new INT- batch code.</li>
          <li>• The switch is recorded in the Audit Log under Stock resets.</li>
        </ul>
        {notCounted.length > 0 && (
          <div className="flex gap-2 rounded-lg border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900" data-testid="stocktake-apply-uncounted">
            <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />
            <div>
              {notCounted.length} material{notCounted.length !== 1 ? "s were" : " was"} not counted and will go to 0:{" "}
              <span className="font-medium">{notCounted.slice(0, 6).map((r) => r.name).join(", ")}{notCounted.length > 6 ? "…" : ""}</span>
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} disabled={busy} data-testid="stocktake-apply-cancel">Cancel</Button>
          <Button className="h-12 px-6 bg-rose-600 hover:bg-rose-700" onClick={onConfirm} disabled={busy} data-testid="stocktake-apply-confirm">
            {busy ? "Switching…" : "Yes, switch stock"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
